import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterDropdown_template} from "../../../common/js/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class monthlyInternalCost_template extends vnTemplate{

    protected brandsFilter: filterDropdown_template;
    protected usersFilter: filterDropdown_template;

    public validationsList: validationsList_template;


    //
    // implementation of base class [vnTemplate]
    protected getTemplateHtml(): string{



        return  `
            <div class="sub-header">
                
                <div class="w-justify">
                    <div class="w-left">
                        <div>
                            <label class="form-label" for="" >Brands</label>
                             ${ this.brandsFilter.getHtmlBuild() }
                        </div>
                        <div>
                            <label class="form-label" for="" >Users</label>
                            ${ this.usersFilter.getHtmlBuild() }
                        </div>
                    </div>
                </div>   
                
            </div>
            
            ${ this.validationsList.getHtmlBuild() }
            
            <div class="list-header w-justify">
                <div class="w-left">
                    <h3 class="section-title icon i-cost">Internal Salary Costs  </h3>
                </div>
            </div>
            
            <div id="list-results">
               <div class="w-list-results form-body ">
                   <table class="list-results list-sections monthly-internal">
                   
                        <thead>
                            <tr>    
                                <th class="align-center border-right"><span>Year</span></th>
                                <!-- ko foreach: years -->
                                    <th class="align-center"><span data-bind="text: $data"></span></th>
                                <!-- /ko -->
                            </tr>
                        </thead>
                        <tbody>
                            <!-- ko foreach: months -->
                                <tr>
                                    <td class="group single"><span data-bind="text: $data"></span></td>
                                    <!-- ko foreach: $parents[0].years -->
                                        <!-- ko if: $parents[1].costData().length !== 0   -->         
                                            <td>
                                                <div class="form-group row">
                                                    <input class="input-text" data-bind="value: $parents[1].costData()[$data][$parentContext.$index()+1].cost"/>
                                                    <button class="btn light only-icon border icon i-copy-down" title="Copy to rest of the year" data-bind="event: {click: function(){ $parents[1].onClickCopyToRestOfYear($data, $parentContext.$index()+1)}}" type="button"></button>
                                                </div>                              
                                            </td>
                                        <!-- /ko -->    
                                    <!-- /ko -->
                                </tr>
                            <!-- /ko -->
                        </tbody>
                        <tfoot>
                            <tr>       
                                <th  data-bind="attr: { colspan: years().length + 1 }">    
                                    <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>                     
                                </th>
                            </tr>
                        </tfoot>
                   </table>
                   
               </div>
            </div>
            `;
    }

    //
    // implementation of base class [vnTemplate]
    protected getTemplateName(): string{
        return "monthlyInternalCost_template";
    }

    //
    // implementation of base class [vnTemplate]
    protected getMainElementClasses(): Array<string>{
        return [""];
    }

    //
    // implementation of base class [vnTemplate]
    protected initPartial(): void {

        this.brandsFilter = new filterDropdown_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setLabel("Brands");

        this.usersFilter = new filterDropdown_template("usersFilter", this.getTemplateViewModel(), this.caller);
        this.usersFilter.setLabel("Users");

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

    }

    //
    // implementation of base class [vnTemplate]
    public buildViewModel(){

        // define the viewModel data/ functions
        let self = this;
        return  {
            years: ko.observableArray([]),
            months: ko.observableArray(["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"]),
            costData: ko.observableArray([]),

            onClickSave: function(data, event){
                self.onClickSave();
            },
            onClickCancel: function(data, event){
                self.onClickCancel();
            },
            onClickCopyToRestOfYear: function(year, month){
                self.onClickCopyToRestOfYear(year, month);
            }
        };
    }

    public getViewModelForRequest(){

        return {
            brandId: this.brandsFilter.getTemplateViewModel().selectedOption,
            userId: this.usersFilter.getTemplateViewModel().selectedOption,
            piLoggedUserId: this.caller.getPiLoggedId()
        }
    }

    public getViewModelForPostRequest(){

        return {
            brandId: this.brandsFilter.getTemplateViewModel().selectedOption,
            userId: this.usersFilter.getTemplateViewModel().selectedOption,
            piLoggedUserId: this.caller.getPiLoggedId(),
            monthlyCosts: this.getTemplateViewModel().costData()
        }
    }

    public onClickSave(): void {

        this.caller.save();
    }

    public onClickCancel(): void {
        this.caller.goHome();
    }

    public onClickCopyToRestOfYear(year, month):void {

        let costData = this.getTemplateViewModel().costData();

        let costToCopy = costData[year][month].cost;

        for (let x = month; x <=12; x++) {

            costData[year][x].cost = costToCopy;
        }

        this.getTemplateViewModel().costData([]);
        this.getTemplateViewModel().costData(costData);
    }

    public setUsers(users): void {

        for (let user of users) {
            user.name = user.fullName;
        }
        this.usersFilter.setOptions(users);
    }

    public setBrands(brands): void {

        this.brandsFilter.setOptions(brands);
    }

    public setYears(years): void {

        this.getTemplateViewModel().years(years);
    }

    public setCostData(data): void {

        let formattedData = [];
        let years = this.getTemplateViewModel().years();
        let months = this.getTemplateViewModel().months();

        for (let year of years) {

            formattedData[year] = [];

            let index = 1;
            for (let month of months) {

                formattedData[year][index] = { cost: "" };
                index++;
            }
        }

        for (let cost of data) {

            formattedData[cost.year][cost.month].cost = cost.cost;
            formattedData[cost.year][cost.month].id = cost.id;
        }

        this.getTemplateViewModel().costData([]);
        this.getTemplateViewModel().costData(formattedData);
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/monthlyInternalCost_template.ts